import { forwardRef, memo } from 'react';

import { Label, Root } from './StatusLabel.styles';
import { StatusLabelProps } from './StatusLabel.types';

/**
 * Represents a status label component.
 * @component
 * @param {string} [size='medium'] - The size of the label. Possible values: 'small', 'medium', 'large'.
 * @param {string} [color='green100'] - The color of the label.
 * @param {boolean} [bordered=true] - Whether the label should have a border.
 * @param {ReactNode} children - The content of the label.
 * @param {ReactNode} [icon] - The icon to display alongside the label content.
 * @returns {ReactElement} The rendered StatusLabel component.
 */
export const StatusLabel = memo(
    forwardRef<HTMLDivElement, StatusLabelProps>((props, ref) => {
        const { size = 'medium', color = 'green100', bordered = true, children, icon } = props;

        return (
            <Root ref={ref} $bordered={bordered} $size={size} $color={color}>
                {icon}

                <Label>{children}</Label>
            </Root>
        );
    })
);

StatusLabel.displayName = 'StatusLabel';
